import { Suspense } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';

const ManualSensors = withLazyLoading(() => import('../../pages/manualSensors'));

const manualInputRoutes = [
  {
    path: '/manual-sensors',
    handle: createCrumbHandle('Manual Sensors'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <ManualSensors />
          </Suspense>
        ),
        // authz-v2 TODO: DataInputTemplate_View_R -> data.inputTemplates.read (needs plantId); server-enforced
      },
    ]
  },
];

export default manualInputRoutes;
